// src/components/ProtectedRoute.tsx
import { Navigate, useLocation } from 'react-router-dom';
import { ReactNode } from "react";
import { useAuth } from "../context/AuthContext.tsx";
import {UserType} from "../api/ApiTypes.ts";

interface ProtectedRouteProps {
    children: ReactNode;
    restrictTo?: UserType[];
}

export const ProtectedRoute = ({
                                   children,
                                   restrictTo = [],// Default to empty array
                               }: ProtectedRouteProps) => {
    // Get authentication state from AuthContext
    const { me, isInitializing } = useAuth();
    // Get current location to redirect back after login
    const location = useLocation();

    if (isInitializing) {
        return null;
    }
    // If not authenticated, redirect to login
    // Include current location in state to redirect back after login
    if (!me) {
        console.log("protected route kicking us out cause no me!")
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (restrictTo.length > 0 && !restrictTo.includes(me.userType)) {
        return <Navigate
            to="/unauthorized"
            state={{
                attemptedUrl: location.pathname,
            }}
        />;
    }

    // If authenticated, render the protected content
    return <>{children}</>;
};